import Icon from '@material-ui/icons/Textsms';
import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import { CreateButton } from '../../../buttons';
import TextMessageCard from '../../../components/TextMessageCard';
import { EditDialog, Filter, ResourceList } from '../../../controllers';
import { BooleanField, DateTimeField, EnumField, LinkField, TextMessageBodyField } from '../../../fields';
import { BooleanInput, EnumInput, LongTextInput, SearchInput, TextInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <EnumField
          source="status"
        />
        <TextMessageBodyField />
        <DateTimeField
          source="created_at"
          sortable
        />
        <BooleanInput
          source="handled"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ organization_id: props.parentResource.id }}
        {...props}
      >
        <EnumInput
          defaultValue="outbound"
          source="template"
          required
        />
        <TextInput
          defaultValue="1"
          source="to_dialing_code"
          required
        />
        <TextInput
          source="to_phone_number"
        />
        <LongTextInput
          source="body"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <EnumField
          source="status"
        />
        <TextMessageBodyField />
        <DateTimeField
          source="created_at"
          sortable
        />
        <BooleanField
          source="handled"
        />
        <LinkField
          reference="users"
          source="handled_by_id"
          allowEmpty
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <EnumInput
          source="status"
        />
        <EnumInput
          filterDefaultValues={{ template: 'inbound' }}
          source="template"
        />
        <BooleanInput

          source="handled"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >
        <TextMessageCard
          id={props.id}
          inbound={props.record.template === 'inbound'}
          record={props.record}
        />
      </SimpleShowLayout>
    ),
  },
  resources: {
  },
};
